var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.pointList),function(item,index){return _c('div',{key:'sceneMaterialPoint'+item.id},[_c('scene-material-point',{attrs:{"pointInfo":item,"pointIndex":index},on:{"clickMarker":_vm.clickMarker}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }